module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christopher Hitchens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Christopher Hitchens was the author of numerous books, including the controversial international bestseller "), _c('I', [_vm._v("God Is Not Great: How Religion Poisons Everything")]), _vm._v(". ")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OQFVKa/tc-custom/9780061753978.jpg?1730610903263",
      "alt": "This image is the cover for the book Thomas Jefferson, Eminent Lives"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Thomas Jefferson, Eminent Lives\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("\"A balanced, readable portrait. A refreshing perspective.” —"), _c('i', [_vm._v("New York Times Book Review")])])]), _c('p', [_c('b', [_vm._v("With intelligence, insight, eloquence, and wit, bestselling author Christopher Hitchens gives us an artful portrait of a complex, formative figure in American history and his turbulent era")]), _vm._v(".")]), _c('p', [_vm._v("In this unique biography of Thomas Jefferson, leading journalist and social critic Christopher Hitchens offers a startlingly new and provocative interpretation of our Founding Father—a man conflicted by power who wrote the Declaration of Independence and acted as ambassador to France yet yearned for a quieter career in the Virginia legislature. A masterly writer, Jefferson was an awkward public speaker. A professed proponent of emancipation, he elided the issue of slavery from the Declaration of Independence and continued to own human property. A reluctant candidate, he left an indelible presidential legacy.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0